import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context'
import { Link } from 'react-router-dom';
import Select from 'react-select';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';

// import { EditorState, convertToRaw } from 'draft-js';
// convertToRaw로 변환시켜준 원시 JS 구조를 HTML로 변환.
// import draftToHtml from 'draftjs-to-html';
import { history } from '../../_helpers';

function ReportWrite() {
  const [report, setReport] = useState()
  const [state, actions] = useContext(UserContext);
  let user = JSON.parse(String(localStorage.getItem('user')))
  const header = {Authorization: `JWT ${user.token}`}

  const [title, setTitle] = useState()
  // const [content, setContet] = useState()
  const [comlist, setComlist] = useState()
  const [company, setCompany] = useState()
  
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  let current_id = history.location.pathname.split('/')[4]

  const onEditorStateChange = (editorState) => {
    // editorState에 값 설정
    setEditorState(editorState);
  };

  function fetchReportPost(){
    // console.log(field, job, fresh)
    // console.log(company, company[0]["id"])
    if(current_id === "add") {
      fetch(state.awslink + "/api/report/", {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": title,
          "company": company[0]["id"],
          "which": company[0]["which"],
          "content": JSON.stringify(convertToRaw(editorState.getCurrentContent())),
        })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
      })
    }

    else{
      fetch(state.awslink + "/api/report/", {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": current_id,
          "title": title,
          "company": company[0]["id"],
          "which": company[0]["which"],
          "content": JSON.stringify(convertToRaw(editorState.getCurrentContent())),
        })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
      })
    }
  }

  useEffect(()=>{
    // async function fetchReportGet(){
    //    fetch(state.awslink + "/api/report/?id=" + current_id, {
    //   method: 'GET',
    //   headers: header,
    //   })
    //   .then(response => response.json())
    //   .then(json=>{
    //     console.log(json)
    //     let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.content))) 
    //     console.log(convertFromRaw(JSON.parse(json.content)))
    //     console.log(parsed)
    //     setEditorState(parsed)
    //     setTitle(json.title)
    //     setReport(json)

    //   }
    //   )
    // }

    async function fetchComlistGet(){
       fetch(state.awslink + "/api/companylist/?hh=true", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)

        let newobj = []

        
        if(json["shopra"])
          if(json["shopra"].length)
            {json["shopra"].map((item, index)=>{
              newobj.push({"value": item.title, "label": item.title, "id": item.id, "which": "shopra"})
              return null
            })}

        if(json["my"])
          if(json["my"].length)
            {json["my"].map((item, index)=>{
              newobj.push({"value": item.title, "label": item.title, "id": item.id, "which": "my"})
              return null
            })}
      
        console.log(newobj)

        setComlist(newobj)
        if(current_id === "add"){
          console.log("new")
          
        }
        else{
          fetch(state.awslink + "/api/report/?id=" + current_id, {
            method: 'GET',
            headers: header,
            })
            .then(response => response.json())
            .then(json=>{
              console.log(json)
              let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.content))) 
              console.log(convertFromRaw(JSON.parse(json.content)))
              console.log(parsed)
              setEditorState(parsed)
              setTitle(json.title)
              setReport(json)
              if(json.company)
                setCompany(newobj.filter((item, i)=> item.id === json.company))
              else if(json.company_second)
                setCompany(newobj.filter((item, i)=> item.id === json.company_second))
      
            }
            )
        }
        
      }
      )
    }


    // if(current_id === "add")  console.log('add')
    // else {
    //   fetchReportGet();
    // }
    fetchComlistGet()
  }, [])

  // console.log(editorState)
  // console.log(JSON.parse(JSON.stringify(editorState)))
  // console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())))
  // console.log(draftToHtml(convertToRaw(JSON.parse(JSON.stringify(editorState)).getCurrentContent())))


  console.log(report, comlist, company)
  return(
    <Wrapper>
      <MidWrapper>
        {current_id === "add" ?
          <CompanyBlock>
            COMPANY
            <Select
              className="report-basic-single"
              defaultValue={null}
              isSearchable={true}
              name="color"
              options={comlist}
              onChange={(e)=>{setCompany(comlist.filter((item, i)=> item.value === e.value))}}
            />
          </CompanyBlock>:
            comlist && report && company ? 
              <CompanyBlock>
                COMPANY
                <Select
                  className="report-basic-single"
                  defaultValue={company[0]}
                  isSearchable={true}
                  name="color"
                  options={comlist}
                  onChange={(e)=>{setCompany(comlist.filter((item, i)=> item.value === e.value))}}
                />
              </CompanyBlock> : null
          }

        <TitleBlock>
          <input value={title} onChange={(e)=>setTitle(e.target.value)}></input>
        </TitleBlock>
        <MyBlock>
          <Editor
            // 에디터와 툴바 모두에 적용되는 클래스
            wrapperClassName="wrapper-class"
            // 에디터 주변에 적용된 클래스
            editorClassName="editor"
            // 툴바 주위에 적용된 클래스
            toolbarClassName="toolbar-class"
            // 툴바 설정
            toolbar={{
              // inDropdown: 해당 항목과 관련된 항목을 드롭다운으로 나타낼것인지
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: false },
            }} 
            placeholder="내용을 작성해주세요."
            // 한국어 설정
            localization={{
              locale: 'ko',
            }}
            // 초기값 설정
            editorState={editorState}
            // 에디터의 값이 변경될 때마다 onEditorStateChange 호출
            onEditorStateChange={onEditorStateChange}
          />
        </MyBlock>
        <button onClick={()=>fetchReportPost()}>
          <Link to={'/recruiter/report'}>저장하기</Link>
          </button>
        {/* <button></button>
        <button></button> */}

      </MidWrapper>
    </Wrapper>   
  )
}

export default ReportWrite;


const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 135px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`


const MidWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 980px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: column;
  .report-basic-single{
    width: 200px;
  }
`

const CompanyBlock = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-start;
  /* margin: auto; */
`

const TitleBlock = styled.div`
  display: flex;

  height: 45px;
  width: 80%;
  margin: 0 auto;
  /* margin-bottom: 4rem; */
  justify-content: flex-start;
  margin-top: 0;
  /* border: 1px solid; */
  >input{
    width: 100%;
    border: 1px solid rgba(0,0,0,0.2) !important;
    :focus{
      outline: none;
    }
  }
`

const MyBlock = styled.div`
  /* margin-top: 100px; */
  .wrapper-class{
      width: 80%;
      margin: 0 auto;
      /* margin-bottom: 4rem; */
  }
  .editor {
    height: 500px !important;
    border: 1px solid rgba(0,0,0,0.2) !important;
    padding: 5px !important;
    border-radius: 2px !important;
    background-color: white;
  }
  .rdw-editor-toolbar{
    border: 1px solid rgba(0,0,0,0.2) !important;
  }

  .rdw-dropdown-wrapper{
    /* z-index: 1; */
  }
`;